import { DefaultTheme, ThemeProps, css, FlattenInterpolation } from 'styled-components';
import { gray } from '@whitelabel/helpers/style/colors';
import { borderRadius } from '@whitelabel/helpers/style/box';

export const plainLinkStyle = css`
  text-decoration: none;
  filter: none;
`;

export const focusLinkStyle = css`
  outline: none;
  border-radius: ${borderRadius('base')};
  box-shadow: 0 0 0 2px ${gray(700)};
`;

export const focusVisibleMixin = (cssCode: FlattenInterpolation<ThemeProps<DefaultTheme>>) => css`
  &:focus-visible {
    ${cssCode}
  }
  @supports not selector(:focus-visible) {
    &:focus {
      /* Fallback for browsers without :focus-visible support */
      ${cssCode}
    }
  }
`;
